import OpenGraphImage from "@components/OpenGraphImage";
import dynamic from "next/dynamic";
const Breadcrumb = dynamic(
  async () => await import("@modules/breadcrumb/Breadcrumb"),
  { ssr: false }
);

interface IDetailArticlePageHeader {
  title?: string;
  blurb?: string;
  ogImage?: string;
}

const DetailArticlePageHeader = ({
  title,
  blurb,
  ogImage,
}: IDetailArticlePageHeader): JSX.Element => {
  return (
    <>
      <OpenGraphImage image={ogImage} alt={title}></OpenGraphImage>
      <div className="mx-auto max-w-[1376px] px-5 desktop:px-0">
        <>
          <div className="h-[1.1875rem]">
            <Breadcrumb />
          </div>
        </>
        <h1 className="my-3 text-h1 font-semibold leading-[115%] desktop:max-w-[842px] desktop:leading-[120%]">
          {title}
        </h1>
        {blurb && (
          <p className="mb-6 max-w-[950px] text-p14 font-normal text-darkgray tablet:pb-3 desktop:mb-0 desktop:block desktop:text-p">
            {blurb}
          </p>
        )}
      </div>
    </>
  );
};

export default DetailArticlePageHeader;
